 <div *ngIf="!statusLoad" class="row">
      <div class="col-12 text-center">
          <div  class="alert alert-warning  text-center" role="alert">
              <i class="fa fa-spinner fa-2x fa-spin"  style="font-size: 25px"></i>
              <br>
              <p><strong>Please Wait</strong>
                <br> Redirecting  to BOCW Service......
                <br><strong> Please don't close the tab</strong>
              </p>
          </div>
      </div>
    </div>
    <div *ngIf="statusLoad" class="row">
      <div class="col-12  text-center text-primary">
          <h3>Punjab Building and Other Construction Worker Welfare Board</h3>
      </div>
     
      <div class="col-md-2 col-sm-12">
      </div>
      <div class="col-md-4 col-sm-12 text-center">
      
          <button class="btn btn-primary btn-lg" id="srch" (click)="workerRedirect()"> Worker Registration </button>
    
      </div>
      <div class="col-md-4 col-sm-12 text-center">
      
          <button class="btn btn-primary btn-lg" id="srch" (click)="bicyclePartOneRedirect()"> Bicycle Part 1 </button>
    
      </div>
      <div class="col-12 mt-5" id="showresult">
      </div>
  </div>